import { render, staticRenderFns } from "./section1.vue?vue&type=template&id=1b880bd3&scoped=true&"
import script from "./section1.vue?vue&type=script&lang=js&"
export * from "./section1.vue?vue&type=script&lang=js&"
import style0 from "./section1.vue?vue&type=style&index=0&id=1b880bd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b880bd3",
  null
  
)

export default component.exports